exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tamanho[data-v-2bd57297]{\r\n    width: 300px;\n}\r\n", ""]);

// exports
